import { render, staticRenderFns } from "./InvoiceDetails.vue?vue&type=template&id=2de8056a&scoped=true&"
import script from "./InvoiceDetails.vue?vue&type=script&lang=ts&"
export * from "./InvoiceDetails.vue?vue&type=script&lang=ts&"
import style0 from "./InvoiceDetails.vue?vue&type=style&index=0&id=2de8056a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2de8056a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2de8056a')) {
      api.createRecord('2de8056a', component.options)
    } else {
      api.reload('2de8056a', component.options)
    }
    module.hot.accept("./InvoiceDetails.vue?vue&type=template&id=2de8056a&scoped=true&", function () {
      api.rerender('2de8056a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/InvoiceDetails.vue"
export default component.exports